import { useState, useEffect } from 'react';
import api from 'utils/api';
import useDeepCompare from 'effects/useDeepCompare';
import useTixlySession from 'effects/useTixlySession';

export default ({ itixUrl, dataAction }) => {
  const {
    client: { saved, programs },
  } = useTixlySession(itixUrl);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let timeout;
    if (dataAction) {
      timeout = setTimeout(() => {
        setStatus(null);
        setMessage(null);
        api(dataAction)
          .then(data => {
            setData(data);
            setStatus(200);
          })
          .catch(({ error, status }) => {
            setStatus(status);
            setMessage(error ?? 'unknown');
          });
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [dataAction, saved]);

  useEffect(() => {
    if (data && !data.purchased && programs.length) {
      setData({
        ...data,
        purchased: programs.indexOf(data.id) > -1,
      });
    }
  }, [useDeepCompare(data), useDeepCompare(programs)]);

  return [data, status, message];
};
